import React from "react";
import styled from "styled-components";


//assets
import doodle from "assets/svg/doodle-1.svg";
import doodleHeader from "assets/svg/doodle-header.svg";
import doodleWork from "assets/svg/doodle-work.svg";
//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components



const PlayBtnWrapper = styled.div`
position: absolute;
top: 50%;
transform: translateY(-50%);

  @media all and (max-width: ${mediaQuery.tablet}) {
    top: 70%;
    &.mid{
      top: 50% !important;
    }
  }
`;

const Button = styled.button`
	
    border: solid 0.4rem ${colors.white};
    padding: 0 2.4rem 0 2.4rem;
    border-radius: 14rem;
    cursor: pointer;
    height: 8.2rem;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    span{
      display: inline-block;
        position: relative;
        top: 2%;
        font-family: 'Trash', sans-serif;
        font-size: ${typographySizes.text.tekstSize7.size.desktop}rem;
        transition: all 0.3s ease-in-out;
    }

    &:hover {
      transform: scale(0.9) !important;
      transition: all 0.3s ease-in-out;
      span{
        transform: scale(0.9) !important;
        transition: all 0.3s 0.1s ease-in-out;
      }
    }
`;

const Doodle = styled.img`
    position: absolute;
    bottom: -1rem;
    left: -1rem;


`;

const DoodleHeader = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(70%, -50%);

`;

const PlayBtn = ({ buttonRef, textRef, className, onOpen, work }) => {

  return (
    <>
    <PlayBtnWrapper ref={buttonRef} className={className}>
        <Button onClick={onOpen}>
            <span ref={textRef}>Play</span></Button>
            
            <Doodle src={doodle} alt="Doodle" />
            <DoodleHeader src={ work ? doodleWork : doodleHeader } alt="Doodle Header" />


    </PlayBtnWrapper>
    </>
  );
};

export default PlayBtn;